export const fetchAllUsers = (state) => state.users.users;
export const allUsersNumber = (state) => state.users.total;
export const allUsersLoading = (state) => state.users.loading;
export const accountRequests = (state) => state.users.requests;
export const selectedUser = (state) => state.users.selectedUser;
export const isCreatedUserSuccessfully = (state) =>
  state.users.createdUserSuccessfully;
